import { CheckSquare, AlertCircle, Calendar, Wallet, MessageCircle, StickyNote, Repeat, Bell, Phone, Users, MapPin } from "lucide-react";

/**
 * Palette + icona per ogni valore dell'ENUM Postgres `task_type`.
 * Sfondo del chip = tinta chiara del colore-tipo.
 * Left-stripe = colore-tipo pieno (immediata distinzione a colpo d'occhio).
 * area color = pallino a sinistra dell'icona (branding delle Life Areas invariato).
 */
export const TYPE_META = {
  task:             { cls: "item-task",     label: "Ciclo",       Icon: CheckSquare,    varName: "--pxos-type-task" },
  deadline:         { cls: "item-deadline", label: "Scadenza",    Icon: AlertCircle,    varName: "--pxos-type-deadline" },
  urgency:          { cls: "item-urgency",  label: "Urgenza",     Icon: AlertCircle,    varName: "--pxos-type-deadline" },
  event:            { cls: "item-event",    label: "Evento",      Icon: Calendar,       varName: "--pxos-type-event" },
  meeting:          { cls: "item-event",    label: "Meeting",     Icon: Users,          varName: "--pxos-type-event" },
  call:             { cls: "item-event",    label: "Call",        Icon: Phone,          varName: "--pxos-type-event" },
  appointment:      { cls: "item-event",    label: "Appuntamento",Icon: MapPin,         varName: "--pxos-type-event" },
  payment_reminder: { cls: "item-payment",  label: "Pagamento",   Icon: Wallet,         varName: "--pxos-type-payment" },
  followup:         { cls: "item-habit",    label: "Follow-up",   Icon: MessageCircle,  varName: "--pxos-type-habit" },
  habit:            { cls: "item-habit",    label: "Abitudine",   Icon: Repeat,         varName: "--pxos-type-habit" },
  note:             { cls: "item-note",     label: "Nota",        Icon: StickyNote,     varName: "--pxos-type-note" },
};

export default function AgendaItem({ task, area, size = "md", onClick, onDragStart, showTime = true }) {
  const type = task.type || "task";
  const meta = TYPE_META[type] || TYPE_META.task;
  const Icon = meta.Icon;
  const overdue = !!task.is_overdue;
  const time = task.scheduled_time || task.due_time || null;
  const areaColor = area?.color || null;

  const cls = [
    "agenda-item",
    meta.cls,
    size === "sm" ? "size-sm" : "",
    overdue ? "is-overdue" : "",
  ].filter(Boolean).join(" ");

  const style = areaColor ? { "--_area-color": areaColor } : {};

  return (
    <div
      draggable
      onDragStart={(e) => {
        e.stopPropagation();
        e.dataTransfer.setData("text/task-id", task.id);
        e.dataTransfer.setData("text/due-date", task.due_date || "");
        onDragStart?.(e);
      }}
      onClick={(e) => { e.stopPropagation(); onClick?.(task); }}
      className={cls}
      style={style}
      title={overdue ? `Scaduto · ${meta.label} · ${task.title}` : `${meta.label} · ${task.title}`}
      data-testid="agenda-item"
      data-task-id={task.id}
      data-task-type={type}
      data-overdue={overdue ? "true" : "false"}
    >
      {areaColor && <span className="area-dot" aria-hidden />}
      <Icon size={size === "sm" ? 10 : 12} className="agenda-item-icon" aria-hidden />
      <span className="agenda-item-title" data-testid="agenda-item-title">
        {overdue && <span aria-label="scaduto" title="Scaduto" style={{ color: "var(--pxos-type-overdue)", fontWeight: 700, marginRight: 4 }}>!</span>}
        {task.title}
      </span>
      {task.recurrence_rule && <Repeat size={size === "sm" ? 9 : 11} className="opacity-60" aria-hidden />}
      {task.reminder_offsets_days?.length > 0 && <Bell size={size === "sm" ? 9 : 11} className="opacity-60" aria-hidden />}
      {showTime && time && <span className="agenda-item-time">{String(time).slice(0, 5)}</span>}
    </div>
  );
}
